import autoBind from 'react-autobind';
import ReactDOM from 'react-dom';
import React, {Component, PropTypes} from 'react';

export default class DocumentDownloader extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    this.downloadDocument();
  }

  componentDidUpdate() {
    this.downloadDocument();
  }

  downloadDocument() {
    const {downloadUrl, onDocumentDownloaded} = this.props;
    if (downloadUrl.trim() === '') return;

    ReactDOM.findDOMNode(this).click();
    onDocumentDownloaded();
  }

  render() {
    const {downloadUrl} = this.props;

    return (
      <a href={downloadUrl} hidden download />
    );
  }
}

DocumentDownloader.propTypes = {
  downloadUrl: PropTypes.string.isRequired,
  onDocumentDownloaded: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/shared/components/DocumentDownloader.js